<div class="container">
  <section class="wrapper">
    <header class="header">{{ 'Subscription.title' | translate }}</header>
    <div class="redline"></div>
    <div class="plansBlock">
      <p class="plansTitle">{{ 'Subscription.selectPlan' | translate }}</p>
      <div class="blocks" *ngIf="flowDataService.flowData$ | async as flowDataRules">
        <app-tarif-block *ngFor="let rule of flowDataService.flowData$ | async; let i = index" [plan]="rule"
          [tarif]="rule.description" [image]="'assets/images/gift-' + ((i % 3) + 1) + '.png'"
          [price]="'$' + rule.amount" [discount]="calculateDiscount(rule)"
          [currentActive]="this.selectedPlan$.getValue()" (setActive)="selectPlan($event)"></app-tarif-block>
      </div>
    </div>
    <div class="paymentsBlock">
      <p class="plansTitle">{{ 'Subscription.selectPayment' | translate }}</p>
      <div class="blocks">
        <app-payment-block *ngFor="let pay of filteredPayMethods$ | async" [title]="pay.payName" [image]="pay.imgUrl"
          [value]="pay" [currentPayment]="paymentMethodService.currentMethod$.getValue()?.payName ?? ''"
          (setPayment)="setCurrentMethod($event)"></app-payment-block>
      </div>
    </div>
    <div class="btnContainer">
      <app-button [text]="'Subscription.buyNow' | translate" (click)="buy()"></app-button>
    </div>
  </section>
</div>